import { useMemo } from 'react';
import { decodeJwtPayload, tokenService, useAuth } from '@aimsos/auth';

/**
 * The signed-in person as the create flow needs them: the platform's own id and
 * a display name.
 *
 * The id is the `user_uuid` claim of the backend token — not `user.id`, which an
 * Auth0 profile does not have. It falls back to the Auth0 subject so a screen
 * rendered without a token still has a stable owner to show.
 *
 * Memoized on primitives: `useAuth()` may hand back a fresh object every render,
 * and a changing identity here would ripple through every callback that closes
 * over it.
 */
export function useCurrentUser() {
  const { user } = useAuth();
  const token = tokenService.getToken();
  const sub = user?.sub ?? '';
  const name = user?.name ?? user?.email ?? '';

  return useMemo(
    () => ({ id: decodeJwtPayload(token)?.user_uuid ?? sub, name }),
    [token, sub, name],
  );
}

export default useCurrentUser;
